import { useContext } from "react";
import { OrderStates, useDictionary } from "@adamlip/okeoke.client";
import { MainContext } from "contexts/MainContext";
import useBasket from "hooks/useBasket";

export default function BasketValue({ isGrid }) {
  const { handleClickCart } = useContext(MainContext);

  const { itemCount, orderState, discountPrice } = useBasket();

  const { getValue } = useDictionary();

  return (
    <div
      className={`flex shrink-0 justify-center items-center p-2 rounded-[var(--general-border-radius)] bg-primary/20 text-primary flex-col ${
        isGrid ? "w-18 h-14" : "w-full max-w-[300px] h-12 mx-auto"
      }`}
      onClick={() => handleClickCart()}
    >
      <div className="font-small">{getValue("app_v2_topBar_cartText")}</div>
      <div className="font-small font-bold">
        <span className="mr-1">
          {itemCount > 0 && orderState === OrderStates.BASKET
            ? discountPrice
            : 0}
        </span>
        <span className="">Ft</span>
      </div>
    </div>
  );
}
